import React, { useCallback, useEffect, useState } from "react";
import { Button, DatePickerInput } from "@shared/components";

import "./index.scss";

export interface DateRange {
  from: Date;
  to: Date;
}

export interface PatientDetailsDateFilterProps {
  disabled?: boolean;
  dateRange: DateRange;
  onChange?: (dateRange: DateRange) => void;
}

const PatientDetailsDateFilter: React.FC<PatientDetailsDateFilterProps> = (props) => {
  const { dateRange, onChange, disabled } = props;
  const { from, to } = dateRange;
  const [newDateRange, setNewDateRange] = useState(dateRange);

  useEffect(() => {
    setNewDateRange(dateRange);
  }, [dateRange]);

  const dateChangeHandler = useCallback((date: Date | null, key: keyof DateRange) => {
    if (!date) return;

    setNewDateRange((values) => ({
      ...values,
      [key]: new Date(date.setSeconds(0)),
    }));
  }, []);

  const timeChangeHandler = useCallback(
    (timeDate: Date | null, key: keyof DateRange) => {
      if (!timeDate) return;

      const date = new Date(newDateRange[key]);
      date.setHours(timeDate.getHours());
      date.setMinutes(timeDate.getMinutes());
      date.setSeconds(0);

      setNewDateRange((values) => ({
        ...values,
        [key]: date,
      }));
    },
    [newDateRange],
  );

  const handleApplyBtnClick = useCallback(() => {
    onChange?.(newDateRange);
  }, [onChange, newDateRange]);

  return (
    <div className="patient-details-filter-container">
      <div className="filter-label">Date Filter:</div>
      <div>
        <DatePickerInput
          disabled={disabled}
          defaultValue={from}
          className="patient-details-filter-input"
          onChange={(e) => dateChangeHandler(e, "from")}
          labelTitle="From"
          labelClassName="patient-details-dp-label"
        />
      </div>
      <div>
        <DatePickerInput
          className="patient-details-filter-input"
          defaultValue={from}
          disabled={!from || disabled}
          onChange={(e) => timeChangeHandler(e, "from")}
          labelTitle=""
          labelClassName="patient-details-dp-label"
          format="HH:mm"
          showMeridian
        />
      </div>
      <div>
        <DatePickerInput
          disabled={disabled}
          defaultValue={to}
          className="patient-details-filter-input"
          onChange={(e) => dateChangeHandler(e, "to")}
          labelTitle="To"
          labelClassName="patient-details-dp-label"
        />
      </div>
      <div>
        <DatePickerInput
          className="patient-details-filter-input"
          defaultValue={to}
          disabled={!to || disabled}
          onChange={(e) => timeChangeHandler(e, "to")}
          labelTitle=""
          labelClassName="patient-details-dp-label"
          format="HH:mm"
          showMeridian
        />
      </div>
      <div>
        <Button
          disabled={!from || !to || disabled}
          onClick={handleApplyBtnClick}
          className="blue full-width patient-details-filter-apply-btn"
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default PatientDetailsDateFilter;
